export default __webpack_public_path__ + "static/media/metamask.02e3ec27.png";